import {createSlice } from '@reduxjs/toolkit';
import {createAsyncThunk } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';
import * as appConfig from '../../components/config';
import moment from 'moment';

const initialState = {
    currentRoute: '',
    token: '',
    username: '',
    generalMessage: {},
    shouldDisplayMessage : false,
    shouldLogout: false,
    transactionHasBeenMade: false,
    accountType: '',
    isLoggedIn: false,
    currentServiceApi: appConfig.default.apiUrls.primaryServices,
    fromDate: moment().subtract(1, 'months').format('DD/MM/YYYY'),
    toDate: moment().format('DD/MM/YYYY'),
    botMessages: [],
    botSessionId: '',
};


export const logout = createAsyncThunk(
    'globalData/logout',
    async (payload, thunkApi) => {
        thunkApi.dispatch({type: 'USER_LOGOUT'})
    }
  );

export const globalDataSlice = createSlice({
    name: 'globalData',
    initialState,
    reducers:{
        setCurrentRoute: (state,action) => 
        {
            state.currentRoute = action.payload
        },
        setIsLoggedIn: (state,action) => 
        {
            state.isLoggedIn = action.payload
        },
        setGlobalDataAccountType: (state,action) =>
        {
            state.accountType = action.payload
        },
        setShouldLogout: (state, action) => 
        {
            state.shouldLogout = action.payload
        },
        setToken: (state,action) => 
        {
            state.token = action.payload
        },
        setGeneralMessage: (state,action) => 
        {
            state.generalMessage = action.payload
            state.shouldDisplayMessage = true
        },
        clearMessage: (state) => 
        {
            state.generalMessage = ''
            state.shouldDisplayMessage = false
        },
        setTransactionHasBeenMade: (state, action) => 
        {
            state.transactionHasBeenMade = action.payload
        },
        setCurrentServiceApi: (state, action)=>
        {
            state.currentServiceApi = action.payload
        },
        setFromDate: (state, action) => 
        {
            state.fromDate = action.payload.fromDate
        },
        setToDate: (state, action) => 
        {
            state.toDate = action.payload.toDate
        },
        setUsername: (state, action) => { 
            state.username = action.payload
        },
         setBotMessages: (state, action) => {
        state.botMessages = action.payload;
        },
        addBotMessage: (state, action) => {
            state.botMessages.push(action.payload);
        },
        setBotSessionId: (state, action) => {
            state.botSessionId = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            })
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'ValidateTokenNew')
                {         
                    if(action.payload.response.code === 1)
                    {
                       state.shouldLogout = true
                    }         
                } 
            })   
    },
})

export const { setCurrentRoute, setGeneralMessage, setToken, setIsLoggedIn, clearMessage, setGlobalDataAccountType, setTransactionHasBeenMade, setShouldLogout, setCurrentServiceApi, setFromDate, setToDate, setUsername, setBotMessages, addBotMessage, setBotSessionId } = globalDataSlice.actions;

export const selectGlobalDataState = (state) => state.globalData;

export default globalDataSlice.reducer;

